
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ai9UQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c8b77f77ae6576928060ea3d90e0659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77e346e30af52e66$var$_react = $77e346e30af52e66$var$_interopRequireDefault((parcelRequire("42omo")));

var $77e346e30af52e66$var$_baseNew = $77e346e30af52e66$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $77e346e30af52e66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/backlog
 * Usage guidance:
 * Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77e346e30af52e66$var$BacklogIcon = (props)=>/*#__PURE__*/ $77e346e30af52e66$var$_react.default.createElement($77e346e30af52e66$var$_baseNew.default, Object.assign({
        name: "BacklogIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$77e346e30af52e66$var$BacklogIcon.displayName = 'BacklogIcon';
var $77e346e30af52e66$var$_default = module.exports.default = $77e346e30af52e66$var$BacklogIcon;

});


//# sourceMappingURL=backlog.5e11ab2b.js.map
